import React from "react";
import "./PrivacyPolicy.css";
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* Dark Hero Header */}
      <div className="relative overflow-hidden bg-[#0a1628] -mt-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-primary-600/20 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-secondary-500/10 blur-[100px]" />
        </div>
        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`, backgroundSize: '60px 60px' }} />
        <div className="relative pt-40 pb-16 sm:pt-48 sm:pb-20">
          <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-primary-300 backdrop-blur-sm">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-secondary-400 animate-pulse" />
              <span className="text-secondary-300">{t('privacy.badge')}</span>
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white tracking-tight">
              {t('privacy.title')}
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg animate-fade-in">
            <div className="space-y-8 text-neutral-700 leading-relaxed">
              <div className="bg-primary-50 rounded-2xl p-6">
                <p className="text-lg">
                  {t('privacy.intro')}
                </p>
              </div>

              <section className="bg-white rounded-2xl p-6 border border-neutral-200">
                <h2 className="text-2xl font-bold text-neutral-900 mb-4">
                  {t('privacy.dataCollected')}
                </h2>
                <ul className="space-y-2 ml-6">
                  {(t('privacy.dataItems', { returnObjects: true }) as string[]).map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <span className="text-primary-500 mt-1">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </section>

              <section className="bg-white rounded-2xl p-6 border border-neutral-200">
                <h2 className="text-2xl font-bold text-neutral-900 mb-4">
                  {t('privacy.purposeTitle')}
                </h2>
                <ul className="space-y-2 ml-6">
                  {(t('privacy.purposeItems', { returnObjects: true }) as string[]).map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <span className="text-primary-500 mt-1">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </section>

              <section className="bg-neutral-50 rounded-2xl p-6">
                <h2 className="text-2xl font-bold text-neutral-900 mb-4">
                  {t('privacy.thirdPartyTitle')}
                </h2>
                <p>
                  {t('privacy.thirdPartyDesc')}
                </p>
              </section>

              <section className="bg-white rounded-2xl p-6 border border-neutral-200">
                <h2 className="text-2xl font-bold text-neutral-900 mb-4">
                  {t('privacy.rightsTitle')}
                </h2>
                <p>
                  {t('privacy.rightsDesc')}
                </p>
              </section>

              <section className="bg-primary-50 rounded-2xl p-6">
                <h2 className="text-2xl font-bold text-neutral-900 mb-4">
                  {t('privacy.contactTitle')}
                </h2>
                <p>
                  {t('privacy.contactDesc')}
                  <br />
                  <strong className="text-primary-600">Email:</strong> info@nairamdal.mn
                </p>
              </section>

              <div className="text-center pt-6 border-t border-neutral-200">
                <p className="text-neutral-500 font-semibold">
                  {t('privacy.lastUpdated')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
